/// <reference path="../../libs.ts" />
import { IAdminInsightsResult } from '../types/IAdminInsightsResult';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class AdminInsightsGetProjectStatusRequest
    extends Request<{},IAdminInsightsResult> {

    constructor() {
        super('getAdminInsightsStatus', {});
    }
}
